import type { MenuItem } from "../menu.type";

import { useNavigationActionAbout } from "@/modules/navigation";

export const useMenuItemAboutAction = (): MenuItem => {
  const { key, text, icon, runAction } = useNavigationActionAbout();

  return {
    key: `${key}-action`,
    label: text,
    icon,
    onClick: runAction,
  };
};
